module.exports = __webpack_public_path__ + "static/media/ic-recommendation-mobile.ddcce916.png";